import { FetchUtils } from '~/utils/fetch-utils';

interface FormInformationApiParam {
	formSubtype?: string;
}

interface FormInformation {
	classicFormName?: string;
}

export class FormInformtionApi {
	public static getFormInformation(
		formName: string,
		params: FormInformationApiParam,
	): Promise<FormInformation> {
		return FetchUtils.getJSON(
			'api/form-information/:formName/:formSubtype',
			{
				formName,
				formSubtype:
					params && params.formSubtype
						? params.formSubtype
						: undefined,
			},
		);
	}
}
